import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const assistantChatShareMutationAtom = createMutationAtomFactory(
  'assistant.chatShare',
  (params: { chatId: string }) => ({
    assistantShareChat: {
      __args: {
        chatId: params.chatId,
      },
      id: true,
      chatId: true,
      token: true,
      createdAt: true,
    },
  }),
);
